export function DebugJSON({
  name,
  json
}: {
  name: string;
  json: Record<string, any>;
}) {
  return <code className="text-xs leading-none text-gray-500" data-sentry-component="DebugJSON" data-sentry-source-file="DebugJSON.tsx">
      <details>
        <summary>
          <b>{name}</b>
        </summary>
        <pre>{JSON.stringify(json, null, 2)}</pre>
      </details>
    </code>;
}